import { Button } from '../button/button';
import { Columns } from '../columns/columns';

export type PaginationProps = {
  pageInfo: {
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    startCursor: string;
    endCursor: string;
  };
  pageSize: number;
  movePage: (direction: -1 | 1) => void;
  pageIndex: number;
};

export const Pagination = ({ pageInfo, pageSize, movePage, pageIndex }: PaginationProps) => {
  if (!pageSize) return null;

  return (
    <Columns
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 16,
          marginBottom: 16,
        }}
      >
        <div style={{ display: 'flex', gap: 16 }}>
          <Button
            variant="secondary"
            size="xs"
            onClick={() => movePage(-1)}
            disabled={!pageInfo.hasPreviousPage || pageIndex === 0}
          >
            Previous
          </Button>
          <Button
            variant="secondary"
            size="xs"
            onClick={() => movePage(1)}
            disabled={!pageInfo.hasNextPage}
          >
            Next
          </Button>
        </div>
      </div>
    </Columns>
  );
};
